import { useTranslate } from "ra-core";
import { RefreshButton } from "@/components/admin/refresh-button";
import { ThemeModeToggle } from "@/components/admin/theme-mode-toggle";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { GlobalSearchButton } from "@/components/atomic-crm/search/GlobalSearchButton";
import { LocaleToggle } from "../login/LocaleToggle";
import { SessionPill } from "../dialer/SessionPill";
import { GavionUserMenu } from "./GavionUserMenu";
import { NotificationsBellSlot } from "./NotificationsBellSlot";

export const GavionTopBar = () => {
  const translate = useTranslate();
  return (
    <header className="sticky top-0 z-20 flex h-14 items-center gap-2 border-b bg-background/95 px-4 backdrop-blur">
      <SidebarTrigger aria-label={translate("gavion.nav.toggle_sidebar")} />
      <div className="max-w-md flex-1">
        <GlobalSearchButton />
      </div>
      <div className="ml-auto flex items-center gap-1">
        <SessionPill />
        <NotificationsBellSlot />
        <LocaleToggle />
        <RefreshButton />
        <ThemeModeToggle />
        <GavionUserMenu />
      </div>
    </header>
  );
};
